/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type ProductType =
  | 'APP'
  | 'THEME'
  | 'MODULE'
  | 'AGENT'
  | 'SOLUTIONS_PARTNER_PROFILE'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type BaseQueryField =
  | 'LISTING_ID'
  | 'ORDERED_LISTING_ID'
  | 'PRODUCT_ID'
  | 'PRODUCT_TYPE'
  | 'OVERALL_RATING'
  | 'ADJUSTED_OVERALL_RATING'
  | 'REVIEW_COUNT'
  | 'INSTALL_COUNT'
  | 'FIRST_PUBLISHED_AT'
  | 'LISTING_LANGUAGE'
  | 'TIER'
  | 'WORKS_WITH_BREEZE'
  | 'WORKFLOW_ACTIONS'
  | 'WORKFLOW_ACTION_NAME'
  | 'WORKFLOW_ACTION_COMPATIBLE_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_IS_TOOL'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENT_APPS'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENTS'
  | 'PRODUCT_FEATURE_TYPE'
  | 'PRODUCT_FEATURE_NAME'
  | 'PRODUCT_FEATURE_METADATA'
  | 'BUILT_BY_HUBSPOT'
  | 'SOURCE_ID'
  | 'USE_CASES'
  | 'DISPLAY_TAG'
  | 'LISTING_NAME'
  | 'LISTING_SLUG'
  | 'CERTIFIED'
  | 'APP_PARTNER_TIER'
  | 'TECHNOLOGY_PARTNER_TIER'
  | 'CONNECTION_TYPE'
  | 'IS_BREEZE_CONNECTOR'
  | 'SYNC_DIRECTION'
  | 'CATEGORY'
  | 'PRICING_PLAN'
  | 'HUBSPOT_FEATURES'
  | 'SUPPORT_LANGUAGES'
  | 'APP_LANGUAGES'
  | 'TOOL_INTEGRATIONS'
  | 'AGENT_TYPE'
  | 'AGENT_TEAM'
  | 'HAS_UBB'
  | 'PROFILE_SOLUTIONS_PARTNER_TIER'
  | 'PROFILE_BUDGET'
  | 'PROFILE_CATALOG_SERVICES'
  | 'PROFILE_INDUSTRIES'
  | 'PROFILE_LANGUAGES'
  | 'PROFILE_ACCREDITATIONS'
  | 'PROFILE_CERTIFICATIONS'
  | 'PROFILE_SUPPORTED_LISTINGS'
  | 'PROFILE_LOCATION_COUNTRY'
  | 'PROFILE_OFFICE_LOCATION'
  | 'PROFILE_PORTAL_ID'
  | 'OBJECTIVE'
  | 'HUB_PLAN'
  | 'REQUIRED_APP_IDS'
  | 'REQUIRED_AGENT_IDS'
  | 'INSTALLED'
  | 'PORTAL_INSTALLABLE'
  | 'REQUIRED_APPS_INSTALLED'
  | unhandledEnumCase;

export type BatchSearchFilterOptionsRequest = {
  filters: Default<Record<string, string[]>>;
  includeHelpText?: boolean;
  language: string;
};

export type BatchSearchFilterOptionsResponse = {
  filterOptions: Default<Record<string, FilterOption[]>>;
};

export type FilterDataType =
  | 'LONG'
  | 'FLOAT'
  | 'BOOLEAN'
  | 'STRING'
  | unhandledEnumCase;

export type FilterOption = {
  value: string;
  text: string;
  slug?: string;
  helpText?: string;
  icon?: string;
};

export type FilterOptionGroup = {
  subheading?: string;
  options: Default<FilterOption[]>;
};

export type PaginatedFilterOptionsRequest = {
  field: BaseQueryField;
  page: number;
  search?: string;
  language: string;
};

export type PaginatedFilterOptionsResponse = {
  options: Default<FilterOption[]>;
  nextPage?: number;
  hasMoreOptions: boolean;
  total: number;
};

export type SearchFilterConfig = {
  field: BaseQueryField;
  dataType: FilterDataType;
  options: Default<FilterOption[]>;
  optionGroups: Default<FilterOptionGroup[]>;
  label: string;
  placeholder?: string;
  defaultValue?: string;
  productTypes: Default<ProductType[]>;
  isMulti: boolean;
  hasMoreOptions?: boolean;
};

export type SearchFilterConfigRequest = {
  language: string;
  productTypes: Default<ProductType[]>;
  includeWorkflowTemplates?: boolean;
};

export type SearchFilterConfigsResponse = {
  filterConfigs: Default<Record<string, SearchFilterConfig>>;
};

export type GetSearchFilterConfigRequestType =
  Requestify<SearchFilterConfigRequest>;
export type GetSearchFilterConfigResponseType = SearchFilterConfigsResponse;
export type GetSearchFilterConfigErrorType = EmptyError & HubspotMetadata;
export const getSearchFilterConfigRpc: ChirpAvroRpcDetails<
  GetSearchFilterConfigRequestType,
  GetSearchFilterConfigResponseType,
  GetSearchFilterConfigErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getSearchFilterConfig',
  auth: 'external',
  fingerprint: 'WjgoerRds_glkXwfPjdc75wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPaginatedSearchFilterOptionsRequestType =
  Requestify<PaginatedFilterOptionsRequest>;
export type GetPaginatedSearchFilterOptionsResponseType =
  PaginatedFilterOptionsResponse;
export type GetPaginatedSearchFilterOptionsErrorType = EmptyError &
  HubspotMetadata;
export const getPaginatedSearchFilterOptionsRpc: ChirpAvroRpcDetails<
  GetPaginatedSearchFilterOptionsRequestType,
  GetPaginatedSearchFilterOptionsResponseType,
  GetPaginatedSearchFilterOptionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getPaginatedSearchFilterOptions',
  auth: 'external',
  fingerprint: 'unUTtSH07dwZqsEVlj9Wj5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBatchSearchFilterOptionsRequestType =
  Requestify<BatchSearchFilterOptionsRequest>;
export type GetBatchSearchFilterOptionsResponseType =
  BatchSearchFilterOptionsResponse;
export type GetBatchSearchFilterOptionsErrorType = EmptyError & HubspotMetadata;
export const getBatchSearchFilterOptionsRpc: ChirpAvroRpcDetails<
  GetBatchSearchFilterOptionsRequestType,
  GetBatchSearchFilterOptionsResponseType,
  GetBatchSearchFilterOptionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getBatchSearchFilterOptions',
  auth: 'external',
  fingerprint: 'AvGlt1OjWd1ntJD5s0o_lZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
